import * as CommonService from "./Api/CommonService";
import * as AuthService from "./Api/AuthService";
import * as FormService from "./Api/FormService";
import * as ProductService from "./Api/ProductService";
import * as GroupOrderDashoard from "./Api/GroupOrderDashoard";
import * as Report from "./Api/Report";

const ApiService = {
  auth: AuthService,
  common: CommonService,
  product: ProductService,
  groupOrderDashboard: GroupOrderDashoard,
  report: Report,
  form: FormService,
  SERVER: "server",
  CLIENT: "client",
};

export default ApiService;
